import * as cartService from '/source/js/services/cartService';
import { showSpinner, hideSpinner } from '/source/_patterns/01-components/spinner/spinner';
import { IS_ACTIVE } from '/source/js/base/baseClasses';
import cartPromotionalProductLine from '/source/_patterns/01-components/cart/partials/cartPromotionalProductLine.hbs';
import cartFreeProductLine from '/source/_patterns/01-components/cart/partials/cartFreeProductLine.hbs';
import cartProductLine from '/source/_patterns/01-components/cart/partials/cartProductLine.hbs';
import availableCouponsModal from '/source/_patterns/01-components/coupon-modal/partials/available-coupons-modal.hbs';
import { addGtmTagTocheckout, setDataForAllProducts, buildDataLayerObject, setTransactionFlowType } from '/source/js/gtm/IsaGtmCommerce';
import { checkCouponsModal, removeCoupon, getToastMessage } from '../checkout/checkout-shared'; //eslint-disable-line
import * as modalUtil from '/source/js/utils/modal/modalUtil';
import * as toast from '/source/js/utils/toastUtil'; //eslint-disable-line
import { clearCouponFieldOnSuccess, UPDATE_TO_CART_LOADING_COMPLETED_MESSAGE, UPDATE_TO_CART_LOADING_ERROR_MESSAGE, UPDATE_TO_CART_LOADING_STARTED_MESSAGE } from '../common/common';

const FORM_LABEL = '.form-label';
const NEW_MEMBER = 'New Member';
const NEW_MEMBER_REWARDS = 'New Member Rewards';
const CHECKOUT = 'Checkout';
const SUBSCRIPTION = 'subscription';
const PC = 'PC';
const RETAIL = 'Retail';
const AUTOSHIP = 'Autoship';
const ASSOCIATE = 'Associate';
let GA_DATA;
let isPageLoad = true;
let INDEX_NAME;

const ActionType = {
    INCREASE: 'Increase',
    DECREASE: 'Decrease',
    REMOVE: 'Remove'
};

function formInput() {
    let $this = $(this);
    $this.addClass(IS_ACTIVE);
    $(FORM_LABEL).addClass(IS_ACTIVE);
    if(!$this.val()) {
        $this.removeClass(IS_ACTIVE);
        $(FORM_LABEL).removeClass(IS_ACTIVE);
    }
}

export async function refreshCart(data) {
    if(data.CartLineDetails.ProductCount === 0) {
        $('.cartSidebar').remove();
        $('.cart__list').remove();
        $('.cart-empty').removeClass('d-none');
        $('.isa-delivery-card').remove();
        let $headerCartItems = $('.header__cart-items');
        $headerCartItems.text('');
        $headerCartItems.addClass('d-none');
        $('.header__cart-count-items').text('empty cart');
        await updateZeroDollar(data);
        updateFooter();
    } else {
        refreshCartTotals(data);
        if(!data.IsaDeliveryAddedFromWidget) {
            refreshCartLines(data);
        }
        refreshCouponPromotions(data.CouponPromotionDetails);
        updateCheckoutCTA(data);
    }
    updateCartMessage(data);
    let pId = $('#selectedMemberType').attr('data-membership-sku');
    if(pId) {
        disableAddRemoveForMembershipSku(pId);
    }
}

async function updateZeroDollar(data) {
    if(!data.IsZeroDollarEnrollment) return;
    let orderFlow = data.OrderFlow;
    if(orderFlow === NEW_MEMBER_REWARDS) {
        $('#checkoutCustomizeZeroDollar').show();
        $('#continueSignupZeroDollar').hide();
    } else if(orderFlow === NEW_MEMBER) {
        $('#checkoutCustomizeZeroDollar').hide();
        $('#continueSignupZeroDollar').show();
    }
    if(data.IsSelfEnrollment && !data.IsAssistedEnrollment && !data.IsRecommendedCartNewMemberRewardsOrderFlow && !data.IsRecommendedCartNewMemberOrderFlow) {
        let cartId = $('#cartName').val();
        let userType = $('#userType').val();
        // orderflow is always NEW MEMBER in ZDE SE
        const requestModel = { cartId: cartId, userType: userType, orderFlow: NEW_MEMBER, isPreview: 'false' };
        showSpinner('Started Cart Context Switch');
        const result = await cartService.switchCartContext(requestModel);
        if(result && result.IsSuccessful) {
            hideSpinner('Completed Cart Context Switch');
            console.log('Switch cart context ZDE');
        } else {
            hideSpinner('Failed Cart Context Switch');
        }
    }
}

function updateCartMessage(result) {
    // toast messages are displayed for Managed Autoship flow
    if(result && result.IsManageAutoship) {
        if(result.IsSuccessful && result.CartMaxThreshold && !result.CartMaxThreshold.IsCartMaximumThreshold) {
            toast.Success(getToastMessage(result));
        } else {
            toast.Error(getToastMessage(result));
        }
    }

    if(result && result.CartMaxThreshold && result.CartMaxThreshold.IsCartMaximumThreshold) {
        $('.cart-max-threshold-error').text(result.CartMaxThreshold.CartMaximumThresholdError);
        $('#cart-max-td-error').removeClass('d-none');
        $('#paypal-button').addClass('d-none');
    } else {
        $('#cart-max-td-error').addClass('d-none');
        $('#paypal-button').removeClass('d-none');
    }
}

function updateCheckoutCTA(data) {
    if(data) {
        checkShippableItem(data);
        checkBVMinimumRequired(data);

        let disableCheckoutCTA = $('#disableCheckoutCTA').val();
        if(disableCheckoutCTA === 'true') {
            $('#checkoutBtn').prop('disabled', true);
        }

        if(data.DisableCheckout) {
            $('#checkoutBtn').prop('disabled', true);
            $('#paypal-button').hide();
        } else {
            $('#checkoutBtn').prop('disabled', false);
            $('#paypal-button').show();
        }
        if(data.IsCartTotalOverMaxLimit) {
            $('.carttotalovermaxlimiterrormsg').removeClass('d-none');
        } else {
            $('.carttotalovermaxlimiterrormsg').addClass('d-none');
        }
    }
}

function checkShippableItem(data) {
    if(!data.IsAssistedEnrollment && !data.DisplayMinimumBVRequired) {
        let isEnrollmentflow = $('#IsEnrollmentflow').val();
        let $cart = $('.cart');
        let $errorMsgContainer = $('#errmsg');
        if(!data.HasShippableItem && isEnrollmentflow === 'true') {
            data.DisableCheckout = true;
            var noshippable = $('.noshippableitemerror');
            if(!noshippable.length) {
                var cartErrorText = $cart.data('noshippableitemerrortext');
                $errorMsgContainer.append(`<p class="product-error product-error--unavailable noshippableitemerror" data-status="${true}"><i class="fal fa-exclamation-circle red900"></i>${cartErrorText}</p>`);
            }
        }
    }
}

function checkBVMinimumRequired(data) {
    let $cart = $('.cart');
    let $errorMsgContainer = $('#errmsg');
    if((data.IsAssistedEnrollment || data.IsRecommendedCartCreate) && data.DisplayMinimumBVRequired) {
        data.DisableCheckout = true;
        var cartErrorText = $cart.data('minimumbvrequiredtext');
        $('.minimum-BV-required').remove();
        $errorMsgContainer.append(`<p class="product-error product-error--unavailable minimum-BV-required" data-status="${true}"><i class="fal fa-exclamation-circle red900"></i>${cartErrorText}</p>`);
        $('#checkoutCustomize').prop('disabled', true);
        $('#checkoutCopy').prop('disabled', true);
        $('#continueSignupBtn').prop('disabled', true);
    } else {
        $('#checkoutCustomize').prop('disabled', false);
        $('#checkoutCopy').prop('disabled', false);
        $('#continueSignupBtn').prop('disabled', false);
        $('.minimum-BV-required').remove();
    }
}

function updateFooter() {
    var currCartItems = document.getElementById('hidden-cartItem-count');
    currCartItems.value = 0;
}

function refreshCartTotals(data) {
    if(!data) {
        console.log('refreshCartTotals - data not set');
        return;
    }
    let $cartTotal = $('.cart__total');
    let cartSidebarTotalItems = '.cart_sidebar_total_items';
    let $cartSidebarSubtotal = $('.cart-sidebar__subtotal');
    let $cartSidebarShipping = $('.cart-sidebar__shipping');
    let $cartSidebarTaxes = $('.cart-sidebar__taxes');
    let $cartSidebarAlternateTaxes = $('.cart-sidebar__alternate-taxes');
    let $cartSidebarEstTotal = $('.cart-sidebar__estimated-total');
    let $cartSidebarDiscounts = $('.cart-sidebar__discounts');
    let $cartSidebarBV = $('.cart-sidebar__bv');
    let $cartSidebarQV = $('.cart-sidebar__qv');
    let $headerCartItemCount = $('.header__cart-items');
    let $cartSidebarEstTotalValue = $('.cart-sidebar__estimated-total-value');
    let $cartSidebarTariffFee = $('.cart-sidebar_tariff-taxes');
    let pp4Msg = $('#ppMsg');
    let hdnPPAmount = $('#hdn-pp-amount');

    if(data.CartLineDetails) {
        $cartTotal.text(data.CartLineDetails.TotalItems);
        $(cartSidebarTotalItems).text(data.CartLineDetails.TotalItems);
        $headerCartItemCount.text(data.CartLineDetails.TotalItems);
        $('.header__cart-count-items').text(data.CartLineDetails.TotalItems + ' items in cart');
    }

    if(data.CartTotals) {
        console.log('CartTotals: ', data.CartTotals);
        $cartSidebarSubtotal.text(data.CartTotals.CartSubTotalForDisplay);
        $cartSidebarShipping.text(data.CartTotals.ShippingAmountForDisplay);
        $cartSidebarTaxes.text(data.CartTotals.TaxesAmountForDisplay);
        if(data.CartTotals.HasAlternateTax) {
            $cartSidebarAlternateTaxes.text(data.CartTotals.AlternateTaxesAmountForDisplay);
        }

        if(data.CartTotals.HasAlternateTax && data.CartTotals.TariffRecoveryFeeAmountForDisplay && $($cartSidebarTariffFee).length) {
            $cartSidebarTariffFee.text(data.CartTotals.TariffRecoveryFeeAmountForDisplay);
        }

        $cartSidebarEstTotal.text(data.CartTotals.EstimatedTotalForDisplay);
        $cartSidebarEstTotalValue.text(data.CartTotals.EstimatedTotal);
        $cartSidebarDiscounts.text(data.CartTotals.DiscountsAndCouponsAmountForDisplay);
        $cartSidebarBV.text(data.CartTotals.BusinessVolumeForDisplay);
        if(data.CartTotals.DisplayQV) {
            $cartSidebarQV.text(data.CartTotals.QualifyingVolumeForDisplay);
        }

        if(pp4Msg) {
            pp4Msg.attr('data-pp-amount', data.CartTotals.EstimatedTotal);
        }

        if(hdnPPAmount) {
            hdnPPAmount.val(data.CartTotals.EstimatedTotal);
        }
    }
}

function refreshCartLines(data) {
    let lineDetails = data.CartLineDetails;
    let $cart = $('.cart');
    let $cartProductList = $('.cart__productlist');
    $cartProductList.empty();
    let properties = {
        EachLabel: $cart.data('eachlabel'),
        RegularLabel: $cart.data('regularlabel'),
        ShowMoreButtonText: $cart.data('showmoretext'),
        ShowLessButtonText: $cart.data('showlesstext'),
        DeleteButtonText: $cart.data('deletetext'),
        EditButtonText: $cart.data('edittext'),
        ShowBV: $cart.data('showbv').toLowerCase() === 'true',
        NextOrderOnlyTooltipMsg: $cart.data('nextorderonlytooltipmsg'),
        NextOrderOnlyLabel: $cart.data('nextorderonlytex'),
        BVLabel: $cart.data('bvlabel'),
        IsSubscriptionFlow: $('#isSubscriptionFlow').val(),
        DeleteButtonHelperText: $cart.data('deletebuttonhelpertext'),
        PackUpdatedMessageSinceLastOrder: $cart.data('pack-update-message')
    };
    lineDetails.CartLines.forEach(function (item) {
        let extendedItem = Object.assign({}, properties, item);
        extendedItem.showPackUpdateMessage = getPackUpdateMessage(item.CartLineId);
        if(item.IsIsaDeliveryProduct) {
            let isaDeliveryLineHtml = cartPromotionalProductLine(extendedItem);
            $cartProductList.append(isaDeliveryLineHtml);
        } else if(item.IsP2AorISproduct) {
            let IsP2AorISproduct = cartPromotionalProductLine(extendedItem);
            $cartProductList.append(IsP2AorISproduct);
        } else if(item.IsFreeGift) {
            const extendedItemWithPriceComparison = { ...extendedItem, ShowFreeGiftBadge: item.IsFreeGift && item.OriginalPricePerUnit >= 1, PromotionalGiftText: data.PromotionalGiftText, QuantityText: data.QuantityLabelText };
            let isaFreeGiftLineHtml = cartFreeProductLine(extendedItemWithPriceComparison);
            $cartProductList.append(isaFreeGiftLineHtml);
        } else {
            if(extendedItem.ShouldNotRenderDelete) {
                if(extendedItem.Quantity === 1) {
                    extendedItem.LockItem = true;
                } else {
                    extendedItem.RestrictItem = true;
                }
            }

            let productLineHtml = cartProductLine(extendedItem);
            $cartProductList.append(productLineHtml);
            let $dataToggleTooltip = $('[data-toggle="tooltip"]');
            if($dataToggleTooltip.length) {
                $dataToggleTooltip.tooltip();
            }
            let $cartShowMore = $('.cart__show-more');
            let $cartPack = $('.cart__item-meta--pack');
            handleShowMoreFunctionality($cartShowMore, $cartPack);
        }
    });
}

const handleShowMoreFunctionality = ($cartShowMoreBtn, $cartPackList) => {
    const isAllFlow = $('#cart-parent-container').hasClass('all-flow');
    const contentTobeToggled = isAllFlow ? 'li:nth-child(n+3)' : 'li:nth-child(n+5)';
    $cartPackList.each(function () {
        let $this = $(this);
        const listItemCondition = isAllFlow ? $this.children('li').length >= 3 : $this.children('li').length > 4;
        if(listItemCondition) {
            $this.find(contentTobeToggled).hide();
            $this.find($cartShowMoreBtn).removeClass('d-none');
        }
    });
};

function refreshCouponPromotions(couponPromotionDetails) {
    let promotionList = couponPromotionDetails.CouponPromotionList;
    let $promotionList = $('.cart-coupon__list');
    $promotionList.empty();
    if((!!promotionList && promotionList.length > 0)) {
        $('.cart-coupon__container').removeClass('d-none');
        $('.cart-coupon__input').removeClass('d-none');
        promotionList.forEach(function (item, index) {
            let $innerSpan = $('<span></span>').text(item.DisplayName);
            let $outerSpan = $('<span>', { class: 'coupon-badge badge' });
            if(item.CouponCode) {
                $outerSpan.data('coupon', item.CouponCode);
            }
            if(item.PromotionId) {
                $outerSpan.data('promotion', item.PromotionId);
            }
            $outerSpan.append($innerSpan);
            if(item.IsRemovable) {
                let $closeBtn = $(`<button type="button" class="removable-coupon" aria-label="Remove promo code ${item.DisplayName}"></button>`);
                $outerSpan.append($closeBtn);
            }
            $promotionList.append($outerSpan);
        });
    }
}

function getPackUpdateMessage(cartLineId) {
    if(!cartLineId) return false;

    if(Array.isArray(window.cartLinesWithUpdates)) {
        return window.cartLinesWithUpdates.includes(cartLineId);
    }

    return false;
}

function showCouponInputForm() {
    let $couponInput = $('.cart-coupon__input');
    if($couponInput.length > 0) {
        $couponInput.removeClass('d-none');
        $('.cart-coupon__container').removeClass('d-none');
    }
}

async function checkCartFeaturedPromotions() {
    let $featuredPromoList = $('.featured-promo-list');
    if($featuredPromoList.length === 0) return;
    $featuredPromoList.empty();
    let results;

    try {
        results = await cartService.getCartFeaturedPromotions();
    } catch (ex) {
        console.log(ex, 'Error getting featured promotions');
        return;
    }

    if(!results || !results.IsSuccessful) return;
    if(!results.FeaturedPromotions || results.FeaturedPromotions.length === 0) return;

    $featuredPromoList.parent().show();
    results.FeaturedPromotions.forEach(function (promoItem) {
        if(promoItem.Text) {
            $featuredPromoList.append(`<li>${promoItem.Text}</li>`);
        }
    });
}

async function updateCartLine(cartLine) {
    try {
        showSpinner(UPDATE_TO_CART_LOADING_STARTED_MESSAGE);
        const result = await cartService.updateCartLine(cartLine);
        if(result && result.IsSuccessful) {
            sendGAEvent(cartLine.cartlineId, cartLine.action, result, cartLine.sku);
            cartService.updateQSForMergeCart();
            await refreshCart(result);
            await checkCartFeaturedPromotions();
            hideSpinner(UPDATE_TO_CART_LOADING_COMPLETED_MESSAGE);
        }
    } catch (e) {
        console.error(e);
        hideSpinner(UPDATE_TO_CART_LOADING_ERROR_MESSAGE);
    }
}

async function updateMembershipSkuCartLine(membershipSkuData) {
    console.log('executing updateMembershipSkuCartLine');
    try {
        showSpinner('Updating cart for membership item started');
        const result = await cartService.updateMembershipSkuCartLine(membershipSkuData);
        if(result && result.IsSuccessful) {
            await refreshCart(result);
            await checkCartFeaturedPromotions();
            disableAddRemoveForMembershipSku(membershipSkuData.productId);
            hideSpinner('Updating cart for membership item completed');
        }
    } catch (e) {
        console.error(e);
        hideSpinner('Updating cart for membership item failed');
    }
}

function disableAddRemoveForMembershipSku(pid) {
    let parent = $('.cart__product[data-pid="' + pid + '"]');
    if(parent && parent.length > 0) {
        let element = $(parent).find('.cart__actions');
        if(element && !$(element).hasClass('d-none')) {
            $(element).addClass('d-none');
        }

        let quantitySelector = $(parent).find('.cart__controls .isa-custom-qty-selector');
        if(quantitySelector && !$(quantitySelector).hasClass('d-none')) {
            $(quantitySelector).addClass('d-none');
        }
    }
}

async function switchCartContext(requestModel) {
    if(isPageLoad) {
        console.log('Skipping switch cart context call on page load.');
        return;
    }
    try {
        showSpinner('Switching cart context started');
        const result = await cartService.switchCartContext(requestModel);
        if(result && result.IsSuccessful) {
            await refreshCart(result);
            await checkCartFeaturedPromotions();
            hideSpinner('Switching cart context completed');
        }
    } catch (e) {
        console.error(e);
        hideSpinner('Switching cart context failed');
    }
}

async function addCouponToCart(request) {
    try {
        showSpinner('Adding coupon to cart started');
        const result = await cartService.addCouponToCart(request);
        hideSpinner('Adding coupon to cart completed');
        return result;
    } catch (e) {
        console.error(e);
        hideSpinner('Adding coupon to cart failed');
    }
}

async function applyCartCoupon(e) {
    e.preventDefault();
    const coupon = $('#coupon').val();
    if(window.validateCoupon && window.validateCoupon($('#coupon'))) {
        let result = await addCouponToCart({ CouponCode: coupon });
        if(result && result.IsSuccessful) {
            await refreshCart(result);
            await checkCartFeaturedPromotions();
            clearCouponFieldOnSuccess($(this));
            window.resetCouponInputField('coupon');
        } else {
            ShowCartCouponApplyFailedMessage(result, false, '#coupon');
        }
        window.disableApplyButtonOnInvalidCouponCode('coupon');
    }
}

async function applyCouponToday() {
    const couponToday = $('#couponToday').val();
    if(window.validateCoupon && window.validateCoupon($('#couponToday'))) {
        let result = await addCouponToCart({ CouponCode: couponToday, CartType: 'todays' });
        if(result && result.IsSuccessful) {
            await refreshCart(result, 'todays');
            await checkCartFeaturedPromotions();
            clearCouponFieldOnSuccess($(this));
            window.resetCouponInputField('couponToday');
        } else {
            ShowCartCouponApplyFailedMessage(result, false, '#couponToday');
        }
        window.disableApplyButtonOnInvalidCouponCode('couponToday');
    }
}

async function applyCouponSubscription() {
    const couponSubscription = $('#couponSubscription').val();
    if(window.validateCoupon && window.validateCoupon($('#couponSubscription'))) {
        let result = await addCouponToCart({ CouponSubscriptionCode: couponSubscription, CartType: 'subscription' });
        if(result && result.IsSuccessful) {
            await refreshCart(result, 'subscription');
            await checkCartFeaturedPromotions();
            clearCouponFieldOnSuccess($(this));
            window.resetCouponInputField('couponSubscription');
        } else {
            ShowCartCouponApplyFailedMessage(result, false, '#couponSubscription');
        }
        window.disableApplyButtonOnInvalidCouponCode('couponSubscription');
    }
}

async function removeCouponPromotionFromCart(request) {
    try {
        showSpinner('Removing coupon promotion from cart started');
        const result = await cartService.removeCouponPromotionFromCart(request);

        if(result && result.IsSuccessful) {
            await refreshCart(result);
            await checkCartFeaturedPromotions();
            hideSpinner('Removing coupon promotion from cart completed');
        }
    } catch (e) {
        console.error(e);
        hideSpinner('Removing coupon promotion from cart failed');
    }
}

async function applyCartCouponFromModal() {
    let $this = $(this);
    if($this && $this.val()) {
        let text = $this.text().trim();
        let appliedText = $this.data('applied-text');

        if(text === appliedText) {
            return;
        }

        let couponCode = $this.val();
        let result = await addCouponToCart({ CouponCode: couponCode, IsCouponFromModal: true });
        if(result && result.IsSuccessful) {
            await refreshCart(result);
            $this.text(appliedText);
            await checkCartFeaturedPromotions();
        } else {
            ShowCartCouponApplyFailedMessage(result, true, '#coupon');
        }
    }
}

function ShowCartCouponApplyFailedMessage(result, isFromModal, couponBox) {
    let $couponInput = $(couponBox);
    let errorText = $couponInput.data('coupon-apply-failed');

    if(isFromModal) {
        errorText = $('.apply_coupon_failed').data('error-message');
    }

    if(result && result.Messages) {
        let msg = result.Messages.find(msg => msg.DisplayMessage === true);
        if(msg && msg.MessageText) errorText = msg.MessageText;
    }
    $couponInput.attr('aria-invalid', 'true');
    if(errorText) {
        if(isFromModal) {
            $('.apply_coupon_failed').text(`${errorText}`);
            $('.apply_coupon_failed').show();
            return;
        }

        $couponInput.parent().addClass('is--error');
        let errorClassText = couponBox.substring(1, couponBox.length);
        $('#coupon-error.error').remove();
        let errorSpan = `<span id="coupon-error" class="error ${errorClassText}-error" role="alert" aria-live="assertive">${errorText}</span>`;
        if($couponInput.length > 0) {
            $couponInput.after(errorSpan);
        }
    }
}

function clearCouponPromotion(e) {
    e.preventDefault();
    e.stopPropagation();
    let $this = $(this);
    const promotion = $this.parent().data('promotion');
    removeCoupon.call(this);
    removeCouponPromotionFromCart({ PromotionId: promotion });
}

function hideAppliedCoupons() {
    let $allCouponsList = $("div[class^='list-card coupon_']");
    $allCouponsList.each(function () {
        let $this = $(this);
        let $button = $this.find('.applyCouponButton');
        if($button.length) {
            let appliedText = $button.data('applied-text');
            if($button.text().trim() === appliedText) {
                $this.hide();
            }
        }
    });
}

async function setAvailableCouponPromotionModal() {
    showSpinner('Fetching available coupon promotions started');
    let response = await cartService.getAvailableCouponsPromotions();
    if(!response || !response.IsSuccessful) {
        hideSpinner('Fetching available coupon promotions failed');
        return;
    }
    hideSpinner('Fetching available coupon promotions completed');
    let availableCoupons = response.AvailableCoupons || [];
    let $modalData = $('.coupon-modal-data');
    let item = {
        IsInCartPage: Boolean($modalData.data('in-cart-page').toLowerCase()),
        PromoType: $modalData.data('promo-type'),
        CurrentMarket: $modalData.data('current-market'),
        CurrentCultureName: $modalData.data('culture-name'),
        ApplyCouponsTitleText: $modalData.data('modal-header'),
        ApplyCouponErrorMessage: $modalData.data('error-message'),
        ExpiresLabelText: $modalData.data('expiration-label-text'),
        CouponCodeLabelText: $modalData.data('coupon-code-label-text'),
        DetailsButtonText: $modalData.data('details-button-text'),
        AppliedButtonText: $modalData.data('applied-text'),
        ApplyButtonText: $modalData.data('apply-text'),
        CancelButtonText: $modalData.data('cancel-button'),
        DoneButtonText: $modalData.data('done-button'),
        AvailableCoupons: availableCoupons
    };
    let modalHTML = availableCouponsModal(item);
    $('.coupon-modal-container').html(modalHTML);
    let $couponsModal = $('#couponsModal');
    $couponsModal.on('hidden.bs.modal', hideAppliedCoupons);
    let $applyCouponModalBtn = $('.cart').find('.applyCouponButton');
    $applyCouponModalBtn.on('click', applyCartCouponFromModal);
    checkCouponsModal('.cart');
    $couponsModal.modal('show');
}

function increaseCartLine() {
    let $this = $(this);
    let num = getItemNumber($this) + 1;
    if(num <= 0 || isNaN(num)) num = 1;
    let clId = $this.parents('.cart__product').data('clid');
    let sku = $this.parents('.cart__product').data('sku');
    updateCartLine({ cartlineId: clId, quantity: num, action: ActionType.INCREASE, sku });
}

function decreaseCartLine() {
    let $this = $(this);
    let num = getItemNumber($this) - 1;
    if(num < 0 || isNaN(num)) num = 0;
    if(num === 0 && ($this.siblings('input').data('locked') === true || $this.siblings('input').data('restricted') === true)) return;
    let clId = $this.parents('.cart__product').data('clid');
    let pId = $this.parents('.cart__product').data('pid');
    let sku = $this.parents('.cart__product').data('sku');
    updateCartLine({ cartlineId: clId, quantity: num, productId: pId, action: ActionType.DECREASE, sku });
    if(num === 0) $this.parents('.cart__product').remove();
}

function updateCartLineQuantity($ele) {
    // $ele is an event if this function is called from an event handler
    // so check for target (which will determine it's an event)
    if($ele.target) {
        $ele = $($ele.target);
    }
    let num = getItemNumber($ele);
    let prev = $ele.data('qty');
    if(prev === num) return;

    if(num < 0 || isNaN(num)) num = 0;
    if(num === 0 && ($ele.data('locked') === true || $ele.data('restricted') === true)) {
        $ele.val(prev);
        return;
    }

    let $cartProduct = $ele.parents('.cart__product');
    let clId = $cartProduct.data('clid');
    let pId = $cartProduct.data('pid');
    let sku = $cartProduct.data('sku');
    updateCartLine({ cartlineId: clId, quantity: num, productId: pId, action: prev < num ? ActionType.INCREASE : ActionType.DECREASE, sku});
    if(num === 0) {
        $cartProduct.remove();
    }
}

function storeCartLineQuantity() {
    let $this = $(this);
    let num = getItemNumber($this);
    $this.data('qty', num);
}

function handleCartLineKeys(e) {
    if(e.which === 13) {
        updateCartLineQuantity($(this));
    }
}

export function removeCartLine() {
    let $this = $(this);
    let $cart = $('.cart');
    let cartData = $cart.data('cart-details');
    let clId = $this.parents('.cart__product').data('clid');
    let pId = $this.parents('.cart__product').data('pid');
    let sku = $this.parents('.cart__product').data('sku');
    let $cartTotal = $('.cart__total');
    let $cartSidebarSubtotal = $('.cart-sidebar__subtotal');
    let $cartSidebarShipping = $('.cart-sidebar__shipping');
    let $cartSidebarTaxes = $('.cart-sidebar__taxes');
    let $cartSidebarAlternateTaxes = $('.cart-sidebar__alternate-taxes');
    let $cartSidebarEstTotal = $('.cart-sidebar__estimated-total');
    let $cartSidebarDiscounts = $('.cart-sidebar__discounts');

    updateCartLine({ cartlineId: clId, quantity: 0, productId: pId, action: ActionType.REMOVE, sku});
    $this.parents('.cart__product').remove();
    if (!!cartData) {//eslint-disable-line
        $cartTotal.text(cartData.CartLineDetails.ProductCount);
        $cartSidebarSubtotal.text(cartData.CartTotals.CartSubTotalForDisplay);
        $cartSidebarShipping.text(cartData.CartTotals.ShippingAmountForDisplay);
        $cartSidebarTaxes.text(cartData.CartTotals.TaxesAmountForDisplay);
        if(cartData.CartTotals.HasAlternateTax) {
            $cartSidebarAlternateTaxes.text(cartData.CartTotals.AlternateTaxesAmountForDisplay);
        }
        $cartSidebarEstTotal.text(cartData.CartTotals.EstimatedTotalForDisplay);
        $cartSidebarDiscounts.text(cartData.CartTotals.DiscountsAndCouponsAmountForDisplay);
    }
}

function getItemNumber($element) {
    let value = '';
    if($element.hasClass('quantity-input')) {
        value = $element.val();
    } else {
        value = $element.siblings('input').val();
    }
    let num = parseInt(value);
    if(num !== isNaN) {
        return num;
    }
    return 0;
}

function emptyCartCta() {
    let $this = $(this);
    window.location.href = $this.data('ctaurl');
}

function showMoreLess() {
    let $this = $(this);
    const isAllFlow = $('#cart-parent-container').hasClass('all-flow');
    const contentTobeToggled = isAllFlow ? 'li:nth-child(n+3)' : 'li:nth-child(n+5)';
    $this.parents('.cart__item-meta--pack').find(contentTobeToggled).toggle();
    $this.toggleClass('flip');
    $this.children('.show-text--more, .show-text--less').toggleClass('d-none');
}

function addGtmTagToCartStep() {
    let $products = [];
    var catalog = window.ga_props[0].CatalogName;
    var category = '';
    window.ga_props[0].Products.forEach(function (item) {
        var product = {
            'name': item.ProductName,
            'id': item.Sku,
            'price': item.Price,
            'brand': item.Brand,
            'category': item.ProductFamilyName,
            'quantity': item.Quantity
        };
        if(item.QueryId && item.QueryId !== null && item.QueryId.trim() !== '') {
            product.queryId = item.QueryId;
        }
        if(product.queryId && product.queryId !== null && product.queryId.trim() !== '') {
            loadIndexNameIfExists();
            if(INDEX_NAME !== undefined && INDEX_NAME !== null) {
                product.indexName = INDEX_NAME;
            }
        }
        $products.push(product);
    });

    var memberId = window.ga_props[0].MemberId;
    var memberType = window.ga_props[0].MemberType;
    var currency = window.ga_props[0].Currency;
    var cultureCode = window.ga_props[0].CultureCode;
    var marketingCloudUserId = window.ga_props[0].MarketingCloudUserId;
    var isagenixMemberSubType = window.ga_props[0].IsagenixMemberSubType;
    var preferredCultureCode = window.ga_props[0].PreferredCultureCode;
    var hasAutoship = window.ga_props[0].HasAutoship;
    var canEnroll = window.ga_props[0].CanEnroll;
    var hasIsaDelivery = window.ga_props[0].HasIsaDelivery;
    var daysSinceEnrollment = window.ga_props[0].DaysSinceEnrollment;
    setDataForAllProducts(catalog, category, currency, memberType, memberId, cultureCode, marketingCloudUserId, isagenixMemberSubType, preferredCultureCode, hasAutoship, canEnroll, hasIsaDelivery, daysSinceEnrollment);
    addGtmTagTocheckout('1', $products);
}

async function getEditUrl() {
    let $this = $(this);
    let $cartProduct = $this.closest('.cart__product');
    let productId = $cartProduct.data('pid');
    let cartLineId = $cartProduct.data('clid');
    let response = await cartService.getProductEditUrl(productId, cartLineId);
    window.location = response.redirectUrl;
}

function initEventHandlers() {
    let $dataToggleTooltip = $('[data-toggle="tooltip"]');
    let $cartShowMore = $('.cart__show-more');
    let $cartPack = $('.cart__item-meta--pack');
    let $emptyCartCta = $('.cartEmpty-Cta');
    let $applyCouponBtn = $('.apply-coupon-btn');
    let $applyCouponTodayBtn = $('.apply-couponToday-btn');
    let $applyCouponSubscriptionBtn = $('.apply-couponSubscription-btn');
    let $checkoutBtn = $('#checkoutBtn');
    let $checkoutCustomize = $('#checkoutCustomize');
    let $checkoutCopy = $('#checkoutCopy');
    let $noPaymentRequiredBtn = $('.noPaymentRequiredBtn');
    let $continueSignupBtn = $('#continueSignupBtn');
    let addMoreProducts = $('#addMoreProductsBtn');
    let $continueSignupZeroDollarBtn = $('#continueSignupZeroDollar');
    let $checkoutCustomizeZeroDollar = $('#checkoutCustomizeZeroDollar');
    let $checkoutZeroDollarBtn = $('#checkoutZeroDollarBtn');

    if($dataToggleTooltip.length) {
        $dataToggleTooltip.tooltip();
    }
    handleShowMoreFunctionality($cartShowMore, $cartPack);
    $(document).on('click', '.cart__show-more', showMoreLess);
    $(document).on('click', '.increase-cartline', increaseCartLine);
    $(document).on('click', '.decrease-cartline', decreaseCartLine);
    $(document).on('focus', '.quantity-input', storeCartLineQuantity);
    $(document).on('blur', '.quantity-input', updateCartLineQuantity);
    $(document).on('keypress', '.quantity-input', handleCartLineKeys);
    $(document).on('click', '.remove-cartline', removeCartLine);
    $(document).on('input', '.form-input', formInput);
    $(document).on('click', '.get-editurl', getEditUrl);
    $(document).on('click', '.cart-coupon__list .removable-coupon', clearCouponPromotion);
    addMoreProducts.on('click', addMoreProductsClick);
    if($('.view-my-coupons-modal').length > 0 && $('.checkout').length === 0) {
        $('.view-my-coupons-modal').on('click', setAvailableCouponPromotionModal);
    }

    $emptyCartCta.on('click', emptyCartCta);
    $applyCouponBtn.on('click', applyCartCoupon);
    $applyCouponTodayBtn.on('click', applyCouponToday);
    $applyCouponSubscriptionBtn.on('click', applyCouponSubscription);
    if($continueSignupBtn.length > 0) {
        $continueSignupBtn.on('click', checkout);
    }
    if($checkoutBtn.length > 0) {
        $checkoutBtn.on('click', checkout);
    }
    if($checkoutCustomize.length > 0) {
        $checkoutCustomize.on('click', checkout);
    }
    if($checkoutCopy.length > 0) {
        $checkoutCopy.on('click', checkout);
    }
    if($noPaymentRequiredBtn.length > 0) {
        $noPaymentRequiredBtn.on('click', checkout);
    }
    if($continueSignupZeroDollarBtn.length > 0) {
        $continueSignupZeroDollarBtn.on('click', checkoutZeroDollar);
    }
    if($checkoutCustomizeZeroDollar.length > 0) {
        $checkoutCustomizeZeroDollar.on('click', checkoutZeroDollar);
    }
    if($checkoutZeroDollarBtn.length > 0) {
        $checkoutZeroDollarBtn.on('click', checkoutZeroDollar);
    }

    $(document).on('click', '.card-border', radioButtonClick);
    $(document).on('change', '.rButton', onRadioButtonClick);

    $('#select-member-type-modal').on('shown.bs.modal', loadMemberTypeModal);

    $(document).on('change', '.memberRadioButton', onRadioMemberTypeClick);
    $(document).on('click', '.member-type-border', radioMemberTypeClick);

    let $btnSaveMemberType = $('#btnSaveMemberType');
    $btnSaveMemberType.on('click', saveMemberTypeSelected);

    $('#subscription-order-datepicker').change(checkNextSubscriptionDate);
    $(document).on('change', '#frequency', checkoutSubscription);
    if($('#hidden-cart-overview-ga-data').length) {
        GA_DATA = $('#hidden-cart-overview-ga-data').data('value');
    }
}

async function checkNextSubscriptionDate() {
    $('#checkoutBtn').prop('disabled', false);
    $('#SubscriptionDateErrorMsg').css('display', 'none');
    $('#disableCheckoutCTA').val('false');
    await checkoutSubscription();
}

function addMoreProductsClick() {
    window.location.href = '/shop';
}

async function onRadioButtonClick() {
    let $radioButton = $(this);
    let isChecked = $radioButton.is(':checked');
    if(!isChecked) {
        return;
    }
    let radioButtonOption = $radioButton.val();
    await inputRadio(radioButtonOption);
    window.location.reload();
}

async function radioButtonClick() {
    try {
        let $radioButton = $(this).children('.rButton');
        let isChecked = $radioButton.is(':checked');
        if(isChecked) {
            return;
        }
        let radioButtonOption = $radioButton.val();
        await inputRadio(radioButtonOption);
    } catch (e) {
        console.log(e);
    }
}

async function inputRadio(option) {
    $(this).is(':checked');
    let cartId = $('#cartName').val();
    let userType = $('#userType').val();
    switch (option) {
        case SUBSCRIPTION:
            $('#subscription-option').prop('checked', true);
            updatesubscriptionProperties();
            await switchCartContext({ cartId: cartId, userType: userType, orderFlow: NEW_MEMBER_REWARDS, isPreview: 'false' });
            $('#isSelfEnrollWithSubscription').val('true');
            hidepaylaterForSubscription();
            break;
        case PC:
            $('#pc-option').prop('checked', true);
            updatePCProperties();
            await switchCartContext({ cartId: cartId, userType: userType, orderFlow: NEW_MEMBER, isPreview: 'false' });
            $('#isSelfEnrollWithSubscription').val('false');
            hidepaylaterForSubscription();
            break;
        case RETAIL:
            $('#rt-option').prop('checked', true);
            updateGuestProperties();
            await switchCartContext({ cartId: cartId, userType: $('#RetailCheckoutOrderFlow').val(), orderFlow: CHECKOUT, isPreview: 'false', switchToGuest: true });
            $('#isSelfEnrollWithSubscription').val('false');
            hidepaylaterForSubscription();
            break;
        case AUTOSHIP:
            updatesubscriptionProperties();
            await switchCartContext({ cartId: cartId, userType: userType, orderFlow: AUTOSHIP, isPreview: 'false' });
            break;
    }
}

async function updatesubscriptionProperties() {
    let $IsAssistedEnrollment = $('#IsAssistedEnrollmentflow').val();
    let $IsRecommendedCart = $('#IsRecommendedCartflow').val();
    let $hasTwoCartsBillingData = $('#HasTwoCartsBillingData').val();
    let isSelfEnrollment = $('#IsSelfEnrollment').val();
    $('#RetailBorder').css('border', '1px solid #EDEEEE');
    $('#PCBorder').css('border', '1px solid #EDEEEE');
    $('#subscriptionBorder').css('border', 'solid 2px #00778B');
    if($IsAssistedEnrollment === 'true' || $IsRecommendedCart === 'true' || isSelfEnrollment === 'true') {
        if($IsAssistedEnrollment === 'true' || $IsRecommendedCart === 'true') {
            // only for ae and rc, self enroll can be true since rc uses same usertype and flow
            if($hasTwoCartsBillingData === 'true') {
                $('#checkoutCustomize').hide();
                $('#checkoutCopy').hide();
                $('#checkoutBtn').show();
            } else {
                $('#checkoutCustomize').show();
                $('#checkoutCopy').show();
                $('#checkoutBtn').hide();
            }
        }
        $('.all-flow #PCBorder').css('border', '1px solid #C5C5C5');
        $('#subscriptionLabel').css('color', '#303030')
            .css('font-weight', '600');
        $('#PCLabel').css('color', '#54585A')
            .css('font-weight', '400');
        $('.mostPopularBadge').css('background', '#4099a8');
        $('#subscriptionRewardsSubHeading').show();
        $('#prefferedSubHeading').hide();
    }
}

async function updatePCProperties() {
    let $IsAssistedEnrollment = $('#IsAssistedEnrollmentflow').val();
    let $IsRecommendedCart = $('#IsRecommendedCartflow').val();
    let isSelfEnrollment = $('#IsSelfEnrollment').val();
    $('#subscriptionBorder').css('border', '1px solid #EDEEEE');
    $('#RetailBorder').css('border', '1px solid #EDEEEE');
    $('#PCBorder').css('border', 'solid 2px #00778B');
    if($IsAssistedEnrollment === 'true' || $IsRecommendedCart === 'true' || isSelfEnrollment === 'true') {
        $('#checkoutCustomize').hide();
        $('#checkoutCopy').hide();
        $('#checkoutBtn').show();
        $('.all-flow #subscriptionBorder').css('border', '1px solid #C5C5C5');
        $('#subscriptionLabel').css('color', '#54585A')
            .css('font-weight', '400');
        $('#PCLabel').css('color', '#303030')
            .css('font-weight', '600');
    }
    $('#subscriptionRewardsSubHeading').hide();
    $('#prefferedSubHeading').show();
}

async function updateGuestProperties() {
    $('#PCBorder').css('border', '1px solid #EDEEEE');
    $('#subscriptionBorder').css('border', '1px solid #EDEEEE');
    $('#RetailBorder').css('border', 'solid 2px #00778B');
    $('#RetailLabel').css('color', '#303030')
        .css('font-weight', '600');
}

function loadMemberTypeModal() {
    if($('#userType').val() === PC) {
        memberTypeSelected(PC);
    } else {
        memberTypeSelected(ASSOCIATE);
    }
}
function onRadioMemberTypeClick() {
    let $radioButton = $(this);
    let isChecked = $radioButton.is(':checked');
    if(!isChecked) {
        return;
    }
    let radioButtonOption = $radioButton.val();
    memberTypeSelected(radioButtonOption);
}

function radioMemberTypeClick() {
    try {
        let $radioButton = $(this).children('.memberRadioButton');
        let isChecked = $radioButton.is(':checked');
        if(isChecked) {
            return;
        }
        let radioButtonOption = $radioButton.val();
        memberTypeSelected(radioButtonOption);
    } catch (e) {
        console.log(e);
    }
}

async function memberTypeSelected(option) {
    $(this).is(':checked');
    switch (option) {
        case ASSOCIATE:
            $('#memberTypeAssociate').prop('checked', true);

            $('#memberTypeAssociateBorder').css('border', 'solid 2px #00778B');
            $('#memberTypePCBorder').css('border', '1px solid #EDEEEE');
            $('#memberTypeAssociateLabel').css('color', '#00778B')
                .css('font-weight', '600');
            $('#memberTypePCLabel').css('color', '#54585A')
                .css('font-weight', '400');
            break;
        case PC:
            $('#memberTypePC').prop('checked', true);

            $('#memberTypeAssociateBorder').css('border', '1px solid #EDEEEE');
            $('#memberTypePCBorder').css('border', 'solid 2px #00778B');
            $('#memberTypeAssociateLabel').css('color', '#54585A')
                .css('font-weight', '400');
            $('#memberTypePCLabel').css('color', '#00778B')
                .css('font-weight', '600');
            break;
    }
}

async function saveMemberTypeSelected() {
    let userType = $('.memberRadioButton:checked').val();
    let cartId = $('#cartName').val();
    let flow = $('.rButton:checked').val();
    let orderFlow = flow === SUBSCRIPTION ? NEW_MEMBER_REWARDS : NEW_MEMBER;
    let shouldHideSubcriptionRewardsPricePoint = false;
    let enrollingAsText = userType === PC ? $('#EnrollingPCText').val() : $('#EnrollingAssociateText').val();

    let isEnrollAssociateOnSubscription = $('#isEnrollAssociateOnSubscription').val();
    if(userType === ASSOCIATE && isEnrollAssociateOnSubscription === 'false') {
        await hideSubscriptionRewardsPricePoint(userType);
        shouldHideSubcriptionRewardsPricePoint = true;
    } else {
        shouldHideSubcriptionRewardsPricePoint = false;
        $('#subscriptionBorder').show();
    }

    $('#selectedMemberType').html(enrollingAsText);
    $('#userType').val(userType);
    let pId = $('#selectedMemberType').attr('data-membership-sku');
    let element = $('#btnSaveMemberType');
    if(element && element.length > 0 && pId && pId.length > 0) {
        let membershipSkuData = { cartId: cartId, quantity: 1, productId: pId, userType: userType };
        if(shouldHideSubcriptionRewardsPricePoint) {
            // orderflow could be NMR if switching from PC NMR input
            // flow must be NM when hiding NMR price point
            orderFlow = NEW_MEMBER;
        }
        await leanSwitchCartContext({ cartId: cartId, userType: userType, orderFlow: orderFlow, isPreview: 'false' }, membershipSkuData);
    }
}

async function leanSwitchCartContext(requestModel, membershipSkuData) {
    try {
        showSpinner('Switching cart context started');
        const result = await cartService.switchCartContext(requestModel);
        if(result && result.IsSuccessful) {
            $('#loading-announcer').text('Cart context switched');
            await refreshCart(result);
            await checkCartFeaturedPromotions();
            if(membershipSkuData.userType === PC) {
                membershipSkuData.quantity = 0;
                updateMembershipSkuCartLine(membershipSkuData);
                $('#loading-announcer').text('membership SKU removed from cart');
            } else {
                updateMembershipSkuCartLine(membershipSkuData);
                $('#loading-announcer').text('membership SKU added to cart');
            }
        }
        hideSpinner('Switching cart context completed');
    } catch (e) {
        hideSpinner('Switching cart context failed');
        console.error(e);
    }
}
async function checkoutSubscription() {
    await checkout(true);
}

async function checkout(subscriptionOnlyChange = false) {
    if($('#cart-max-td-error').length) {
        if(!$('#cart-max-td-error').hasClass('d-none')) { return; }
    }
    showSpinner('Starting checkout process');
    try {
        let $this = $(this); //eslint-disable-line
        let couponCode = ''; //eslint-disable-line
        let assistedEnrollmentAction = ''; //eslint-disable-line
        let isNoPaymentRequired = false; //eslint-disable-line

        let $isNoPaymentRequired = $('#isNoPaymentRequired');

        if($isNoPaymentRequired.length > 0) {
            isNoPaymentRequired = $isNoPaymentRequired.val();
        }

        if($this.data('nopaymentrequiredcouponcode')) {
            couponCode = $this.data('nopaymentrequiredcouponcode');
        }

        if($this.data('assistedenrollmentaction')) {
            assistedEnrollmentAction = $this.data('assistedenrollmentaction');
        }

        let contextItemId = $('#hidden-contextItem-id').val();
        let datasourceItemId = $('#hidden-datasource-id').val();

        if(typeof subscriptionOnlyChange === 'object') {
            subscriptionOnlyChange = false;
        }

        let request = {
            CouponCode: couponCode,
            IsNoPaymentRequired: isNoPaymentRequired,
            ContextItemId: contextItemId,
            DatasourceItemId: datasourceItemId,
            AssistedEnrollmentAction: assistedEnrollmentAction,
            SubscriptionOnlyChange: subscriptionOnlyChange
        };

        // subscription Setup
        let $nextSubscriptionDate = $('#subscription-order-datepicker');
        if($nextSubscriptionDate.length > 0) {
            let date = $nextSubscriptionDate.val();
            let format = $nextSubscriptionDate.attr('data-date-format');
            request.NextSubscriptionDate = getDateFormatted(date, format);
        }
        let $frequency = $('#frequency');
        if($frequency.length > 0) {
            request.Frequency = $frequency.val();
        }

        let result = await cartService.startCheckout(request);

        if(subscriptionOnlyChange) {
            if(result.Messages.length > 0) {
                if(result.IsSuccessful) {
                    toast.Success(getToastMessage(result));
                } else {
                    toast.Error(getToastMessage(result));
                }
            }
        } else if(result.IsSuccessful) {
            if(couponCode) {
                // remove no payment required widget
                $('.promo-caboSession').remove();
            }
            if(result.ShowMessageModal) {
                let modalData = $('.cart').data('modal');
                modalData.title = result.Messages[1].MessageText;
                modalData.content = result.Messages[0].MessageText;
                modalData.hideCloseButton = true;

                modalUtil.showError(result, modalData, () => {
                    window.location = result.CheckoutNextPageUrl;
                });
            } else {
                window.location = result.Data;
            }
        }
    } catch (ex) {
        console.error(ex);
        hideSpinner('Starting checkout process failed');
    }
    hideSpinner('Starting checkout process halted');
}

async function checkoutZeroDollar() {
    showSpinner('Starting zero dollar checkout process');
    try {
        let $this = $(this); //eslint-disable-line
        let assistedEnrollmentAction = ''; //eslint-disable-line

        if($this.data('assistedenrollmentaction')) {
            assistedEnrollmentAction = $this.data('assistedenrollmentaction');
        }

        let contextItemId = $('#hidden-contextItem-id').val();
        let datasourceItemId = $('#hidden-datasource-id').val();

        let request = {
            ContextItemId: contextItemId,
            DatasourceItemId: datasourceItemId,
            AssistedEnrollmentAction: assistedEnrollmentAction
        };

        let result = await cartService.startCheckoutZeroDollar(request);
        if(result.IsSuccessful) {
            if(result.ShowMessageModal) {
                let modalData = $('.cart').data('modal');
                modalData.title = result.Messages[1].MessageText;
                modalData.content = result.Messages[0].MessageText;
                modalData.hideCloseButton = true;

                modalUtil.showError(result, modalData, () => {
                    window.location = result.CheckoutNextPageUrl;
                });
            } else {
                window.location = result.Data;
            }
        }
    } catch (ex) {
        console.error(ex);
        hideSpinner('Starting zero dollar checkout process failed');
    }
    hideSpinner('Starting zero dollar checkout process halted');
}

function getDateFormatted(date, format) {
    if(date.indexOf('.') !== -1) {
        date = date.replace(/\./g, '-');
    } else {
        date = date.replace(/\//g, '-');
    }
    format = format.replace(/\//g, '-');
    const dateParts = date.split('-');
    const formatParts = format.split('-');
    let dayKey, monthKey, yearKey;
    for (let i = 0; i < formatParts.length; i++) {
        if(formatParts[i].includes('d')) {
            dayKey = formatParts[i];
        }
        if(formatParts[i].includes('m')) {
            monthKey = formatParts[i];
        }
        if(formatParts[i].includes('y')) {
            yearKey = formatParts[i];
        }
    }

    const day = parseInt(dateParts[formatParts.indexOf(dayKey)]);
    const month = parseInt(dateParts[formatParts.indexOf(monthKey)]);
    const year = parseInt(dateParts[formatParts.indexOf(yearKey)]);

    let strDay = day < 10 ? '0' + day : day;
    let strMonth = month < 10 ? '0' + month : month;
    return strMonth + '-' + strDay + '-' + year;
}

function updatePromotionalProductLines() {
    let $promoProductIds = $('#hidden-promoproduct-ids');
    if($promoProductIds.length) {
        let promotionalProductIdsData = $promoProductIds.val();
        let array = promotionalProductIdsData.toString().split('|');
        for (let i = 0; i < array.length; i++) {
            let cartLineEditButton = $('.cart__product[data-pid="' + array[0] + '"] a.btn-link');
            if(cartLineEditButton.length) {
                cartLineEditButton.remove();
            }
            let cartLineAmountGroup = $('.cart__product[data-pid="' + array[0] + '"] .price__group--amount');
            if(cartLineAmountGroup.length) {
                cartLineAmountGroup.remove();
            }
        }
    }
}

async function priceRadioLoad() {
    let isAssistedEnrollment = $('#IsAssistedEnrollmentflow').val();
    let isRecommendedCart = $('#IsRecommendedCartflow').val();
    let isSelfEnrollment = $('#IsSelfEnrollment').val();
    let showRetailCheckout = $('#ShowRetailCheckout').val();

    if(isAssistedEnrollment === 'true' || isRecommendedCart === 'true' || isSelfEnrollment === 'true' || showRetailCheckout === 'true') {
        let isCurrentFlowSubscription = $('#IsCurrentFlowSubscription').val();
        let userType = $('#userType').val();
        let isEnrollAssociateOnSubscription = $('#isEnrollAssociateOnSubscription').val();
        if(userType === ASSOCIATE && isEnrollAssociateOnSubscription === 'false') {
            await hideSubscriptionRewardsPricePoint(userType);
        } else if(isCurrentFlowSubscription === 'true') {
            await inputRadio(AUTOSHIP);
        } else {
            let orderFlow = $('#orderFlow').val();
            switch (orderFlow) {
                case NEW_MEMBER:
                    await inputRadio(PC);
                    break;
                case NEW_MEMBER_REWARDS:
                    await inputRadio(SUBSCRIPTION);
                    break;
                case CHECKOUT:
                    await inputRadio(RETAIL);
                    break;
            }
        }
    }
}

async function hideSubscriptionRewardsPricePoint(userType) {
    let cartId = $('#cartName').val();
    $('#subscriptionBorder').hide();
    $('#pc-option').prop('checked', true);
    updatePCProperties();
    await switchCartContext({ cartId: cartId, userType: userType, orderFlow: NEW_MEMBER, isPreview: 'false' });
}

function AddMembershipSku() {
    let userType = $('#userType').val();
    let cartId = $('#cartName').val();
    let pId = $('#selectedMemberType').attr('data-membership-sku');
    let parent = $('.cart__product[data-pid="' + pId + '"]');
    let element = $('#btnSaveMemberType');
    if(element && element.length > 0 && pId && pId.length > 0) {
        if(parent && parent.length > 0) {
            console.log('membership sku already present');
        } else {
            if(userType === ASSOCIATE) {
                console.log('add membership sku on load');
                updateMembershipSkuCartLine({ cartId: cartId, quantity: 1, productId: pId, userType: userType });
            }
        }
        disableAddRemoveForMembershipSku(pId);
    }
}

window.onload = function () {
    hidepaylaterForSubscription();
};

function hidepaylaterForSubscription() {
    const buttons = $('.paypal-buttons');
    let isSubscrtiptionSelfEnrollment = $('#isSelfEnrollWithSubscription').val();

    if(buttons.length >= 2) {
        const secondButton = buttons.eq(1);
        if(isSubscrtiptionSelfEnrollment === 'true') {
            if(!secondButton.hasClass('d-none')) {
                secondButton.addClass('d-none');
            }
        } else {
            if(secondButton.hasClass('d-none')) {
                secondButton.removeClass('d-none');
            }
        }
    }
}

function sendGAEvent(cartLineId, action, result, sku) {
    try {
        console.log('sendGAEvent called with:', { cartLineId, action, result, sku });
        if(!isValidResult(result)) {
            return;
        }

        const cartLines = result.CartLineDetails.CartLines;
        let productInfo = findProductInfo(cartLines, cartLineId, sku, result.GoogleAnalyticsProperties);
        if(!productInfo) return;

        const isCompletelyRemoved = productInfo.isCompletelyRemoved;
        const originalProductInfo = productInfo.product;

        const updatedProduct = getUpdatedProduct(originalProductInfo, result.GoogleAnalyticsProperties, sku, isCompletelyRemoved);
        if(!updatedProduct) return;

        const eventName = mapActionToEventName(action);
        if(!eventName) return;
        if(originalProductInfo && originalProductInfo.QueryId && originalProductInfo.QueryId !== null && originalProductInfo.QueryId !== '') {
            if(INDEX_NAME === null || INDEX_NAME === '' || INDEX_NAME === undefined) {
                loadIndexNameIfExists();
            }
        }
        let addIndexprop = false;
        if(originalProductInfo && originalProductInfo.QueryId !== null && originalProductInfo.QueryId !== '') {
            updatedProduct.queryId = originalProductInfo.QueryId;
            addIndexprop = true;
        }
        if(addIndexprop && INDEX_NAME !== null && INDEX_NAME !== '' && INDEX_NAME !== undefined) {
            updatedProduct.indexName = INDEX_NAME;
        }
        const updatedGA = {
            ...result.GoogleAnalyticsProperties,
            Products: [updatedProduct],
            EventName: eventName
        };

        const dataLayerObject = buildDataLayerObject(updatedGA, eventName, action === ActionType.INCREASE);
        (window.dataLayer || []).push(setTransactionFlowType(dataLayerObject));
    } catch (error) {
        console.error('Error in sendGAEvent:', error);
    }
}

function isValidResult(result) {
    return result && result.CartLineDetails && Array.isArray(result.CartLineDetails.CartLines);
}

function findProductInfo(cartLines, cartLineId, sku, googleAnalytics) {
    let product = cartLines.find(p => p.CartLineId === cartLineId);
    if(product) return { product, isCompletelyRemoved: false };

    if(GA_DATA && Array.isArray(GA_DATA.Products)) {
        const matchingGAProducts = GA_DATA.Products.filter(p => p.Sku.toString() === sku.toString());

        if(matchingGAProducts.length > 1) {
            const stillAvailableProducts = googleAnalytics.Products.filter(p => p.Sku.toString() === sku.toString());
            product = matchingGAProducts.find(gaProduct => !stillAvailableProducts.some(ga => ga.Price === gaProduct.Price));
        } else {
            product = matchingGAProducts[0];
        }

        if(product) return { product, isCompletelyRemoved: true };
    }

    return null;
}

function getUpdatedProduct(productInfo, googleAnalytics, sku, isCompletelyRemoved) {
    if(isCompletelyRemoved) {
        return { ...productInfo, Quantity: 0 };
    }

    if(!googleAnalytics || googleAnalytics.EventName === null) {
        return null;
    }

    let pricePerUnit = productInfo.OriginalPricePerUnit;
    const formattedPrice = pricePerUnit.toFixed(5);

    if(!Array.isArray(googleAnalytics.Products)) return null;

    return googleAnalytics.Products.find(
        p => p.Sku === sku.toString() && !Number.isNaN(Number(p.Price)) && Number(p.Price).toFixed(5) === formattedPrice
    );
}

function mapActionToEventName(action) {
    switch (action) {
        case ActionType.INCREASE:
            return 'addToCart';
        case ActionType.DECREASE:
        case ActionType.REMOVE:
            return 'removeFromCart';
        default:
            console.log(`Unknown action type: ${action}`);
            return null;
    }
}

function loadIndexNameIfExists() {
    INDEX_NAME = window.algoliaData.searchIndexName;
}

$(async function () {
    initEventHandlers();
    updatePromotionalProductLines();
    showCouponInputForm();
    checkCouponsModal('.cart');
    addGtmTagToCartStep();
    await checkCartFeaturedPromotions();
    await priceRadioLoad();
    AddMembershipSku();
    isPageLoad = false;
    hidepaylaterForSubscription();
});
